var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAptm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.754 11.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aa{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.978 -112.81)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1300.544 -675.13)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1325.986,794.356h.585l.027,0a.384.384,0,0,0,.361-.38v-.59a.382.382,0,0,0-.383-.382h-.59a.382.382,0,0,0-.382.382v.59A.382.382,0,0,0,1325.986,794.356Z",
    transform: "translate(-0.881 -0.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1328.68,796.716h.59l.039,0,0,0a.384.384,0,0,0,.342-.377v-.591a.383.383,0,0,0-.383-.383h-.59a.382.382,0,0,0-.382.383v.591A.382.382,0,0,0,1328.68,796.716Z",
    transform: "translate(-1.217 -0.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1325.986,796.716h.585l.027,0a.383.383,0,0,0,.361-.379v-.591a.383.383,0,0,0-.383-.383h-.59a.382.382,0,0,0-.382.383v.591A.382.382,0,0,0,1325.986,796.716Z",
    transform: "translate(-0.881 -0.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1331.381,794.356h.589l.088,0v-.011a.385.385,0,0,0,.3-.37v-.59a.382.382,0,0,0-.383-.382h-.589a.382.382,0,0,0-.383.382v.59A.382.382,0,0,0,1331.381,794.356Z",
    transform: "translate(-1.553 -0.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1331.381,796.716h.589l.088,0v-.01a.385.385,0,0,0,.3-.37v-.591a.383.383,0,0,0-.383-.383h-.589a.382.382,0,0,0-.383.383v.591A.382.382,0,0,0,1331.381,796.716Z",
    transform: "translate(-1.553 -0.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1328.68,794.356h.59l.039,0,0,0a.384.384,0,0,0,.342-.378v-.59a.382.382,0,0,0-.383-.382h-.59a.382.382,0,0,0-.382.382v.59A.382.382,0,0,0,1328.68,794.356Z",
    transform: "translate(-1.217 -0.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1323.288,794.356h.582l.022,0a.384.384,0,0,0,.368-.38v-.59a.382.382,0,0,0-.382-.382h-.59a.383.383,0,0,0-.383.382v.59A.383.383,0,0,0,1323.288,794.356Z",
    transform: "translate(-0.545 -0.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1320.592,799.076h.58l.012,0a.384.384,0,0,0,.383-.38v-.59a.382.382,0,0,0-.383-.382h-.592a.382.382,0,0,0-.383.382v.59A.382.382,0,0,0,1320.592,799.076Z",
    transform: "translate(-0.21 -1.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1331.008,787.94h-11.217a1.27,1.27,0,0,0-1.27,1.27v8.854a1.27,1.27,0,0,0,1.27,1.269h11.217a1.269,1.269,0,0,0,1.268-1.269V789.21A1.269,1.269,0,0,0,1331.008,787.94Zm.5,3.719v6.408a.5.5,0,0,1-.5.5h-11.218a.505.505,0,0,1-.5-.5v-6.408Zm0-2.45v1.684h-12.224V789.21a.507.507,0,0,1,.5-.5h11.217A.5.5,0,0,1,1331.511,789.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1325.986,799.075h.58a.383.383,0,0,0,.383-.383v-.59a.382.382,0,0,0-.383-.382h-.581v0a.381.381,0,0,0-.379.383v.59A.382.382,0,0,0,1325.986,799.075Z",
    transform: "translate(-0.881 -1.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1320.592,796.716h.58l.012,0a.383.383,0,0,0,.383-.379v-.591a.383.383,0,0,0-.383-.383h-.592a.382.382,0,0,0-.383.383v.591A.382.382,0,0,0,1320.592,796.716Z",
    transform: "translate(-0.21 -0.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1323.288,799.076h.582l.022,0a.384.384,0,0,0,.368-.38v-.59a.382.382,0,0,0-.382-.382h-.59a.383.383,0,0,0-.383.382v.59A.384.384,0,0,0,1323.288,799.076Z",
    transform: "translate(-0.545 -1.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1323.288,796.716h.582l.022,0a.384.384,0,0,0,.368-.379v-.591a.382.382,0,0,0-.382-.383h-.59a.384.384,0,0,0-.383.383v.591A.383.383,0,0,0,1323.288,796.716Z",
    transform: "translate(-0.545 -0.924)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAptm);
export default __webpack_public_path__ + "static/media/aptm.3bdddc8b.svg";
export { ForwardRef as ReactComponent };